import { render, staticRenderFns } from "./CompletedFlows.vue?vue&type=template&id=71b036be&scoped=true"
import script from "./CompletedFlows.vue?vue&type=script&lang=js"
export * from "./CompletedFlows.vue?vue&type=script&lang=js"
import style0 from "./CompletedFlows.vue?vue&type=style&index=0&id=71b036be&prod&lang=sass&scoped=true"
import style1 from "./CompletedFlows.vue?vue&type=style&index=1&id=71b036be&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b036be",
  null
  
)

export default component.exports